module.exports = __webpack_public_path__ + "img/19_newYouth_qyt.62e99585.png";